import ReactDOM from 'react-dom';
import { Root } from './Root';

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<Root />, document.getElementById('root'));
